/* ============================================================
 * JPF Marketplace Product Page — Step 4.5 v3 + Step 4.6 #1 + #2
 * Adds: cm/inch toggle, watermark overlay, right-click block,
 *       custom size note → cart property, modal hierarchy v3,
 *       per-fabric bulk-price hint (Step 4.6 #1),
 *       locale-aware default size unit yard/meter (Step 4.6 #2),
 *       eco print badge + quantity note for woven fabrics (5–20 m).
 * ============================================================ */
(function () {
  'use strict';

  const FABRIC_META = {
    'Stretch Cotton Jersey — 210 gsm':    { tab: 'knit',  sample: false, minYd: 5,  weightGPerYd: 500 },
    'Organic Cotton Jersey — 210 gsm':    { tab: 'knit',  sample: false, minYd: 5,  weightGPerYd: 500 },
    'French Terry — 250 gsm':             { tab: 'knit',  sample: false, minYd: 5,  weightGPerYd: 580 },
    'Brushed French Terry — 250 gsm':     { tab: 'knit',  sample: false, minYd: 5,  weightGPerYd: 580 },
    'French Terry — 300 gsm':             { tab: 'knit',  sample: false, minYd: 5,  weightGPerYd: 690 },
    'Brushed French Terry — 300 gsm':     { tab: 'knit',  sample: false, minYd: 5,  weightGPerYd: 690 },
    'Rib Knit — 230 gsm':                 { tab: 'knit',  sample: false, minYd: 5,  weightGPerYd: 530 },
    'Viscose Jersey — 200 gsm':           { tab: 'knit',  sample: false, minYd: 5,  weightGPerYd: 460 },
    'Modal/Cotton Jersey — 200 gsm':      { tab: 'knit',  sample: false, minYd: 5,  weightGPerYd: 460 },
    'Quilting Cotton — 120 gsm':          { tab: 'woven', sample: false, minYd: 5,  weightGPerYd: 280 },
    'Cotton Voile — 80 gsm':              { tab: 'woven', sample: false, minYd: 5,  weightGPerYd: 190 },
    '2 Layers Muslin (Gauze) — 120 gsm':  { tab: 'woven', sample: false, minYd: 5,  weightGPerYd: 280 },
    '4 Layers Muslin (Gauze) — 200 gsm':  { tab: 'woven', sample: false, minYd: 5,  weightGPerYd: 460 },
    'Woven Viscose — 120 gsm':            { tab: 'woven', sample: false, minYd: 5,  weightGPerYd: 280 },
    'Cotton Canvas — 210 gsm':            { tab: 'woven', sample: false, minYd: 5,  weightGPerYd: 500 },
    'Cotton Canvas — 300 gsm':            { tab: 'woven', sample: false, minYd: 5,  weightGPerYd: 690 },
    'Swimsuit Lycra — 180 gsm':           { tab: 'lycra', sample: true,  minYd: 1,  weightGPerYd: 430 },
    'Sport Lycra — 230 gsm':              { tab: 'lycra', sample: true,  minYd: 1,  weightGPerYd: 530 },
    'Softshell with Fleece — 300 gsm':    { tab: 'lycra', sample: true,  minYd: 1,  weightGPerYd: 690 },
    'Rainwear — 120 gsm':                 { tab: 'lycra', sample: true,  minYd: 1,  weightGPerYd: 280 },
    'Board Short — 90 gsm':               { tab: 'lycra', sample: true,  minYd: 1,  weightGPerYd: 210 },
    'Fleece — 280 gsm':                   { tab: 'lycra', sample: true,  minYd: 1,  weightGPerYd: 640 },
    'Mesh (tulle-net)':                   { tab: 'poly',  sample: true,  minYd: 1,  weightGPerYd: 160 },
    'Heavy Sport Lycra — 300 gsm':        { tab: 'lycra', sample: true,  minYd: 1,  weightGPerYd: 690 },
    '100% Real Silk Satin — 90 gsm':      { tab: 'silk',  sample: true,  minYd: 1,  weightGPerYd: 210 },
    // 23 Tem 2026'da her desene eklenen 6 dokuma (reaktif, min 5). Adlar varyant
    // adiyla birebir; gsm adda yoksa kartta gostermek icin ayrica tutulur.
    'Cotton Lawn':                        { tab: 'woven', sample: false, minYd: 5,  weightGPerYd: 180, gsm: 78 },
    'Cotton Poplin 115 gsm':              { tab: 'woven', sample: false, minYd: 5,  weightGPerYd: 260, gsm: 115 },
    'Stretch Cotton Sateen':              { tab: 'woven', sample: false, minYd: 5,  weightGPerYd: 280, gsm: 123 },
    'Linen':                              { tab: 'woven', sample: false, minYd: 5,  weightGPerYd: 290, gsm: 125 },
    'Cotton Twill 280 gsm':               { tab: 'woven', sample: false, minYd: 5,  weightGPerYd: 640, gsm: 280 },
    'Cotton Canvas':                      { tab: 'woven', sample: false, minYd: 5,  weightGPerYd: 670, gsm: 290 },
    // 13 polyester orme (sublimasyon, min 1). Sekme, PYO'daki custom.fabric_category ile ayni.
    'Spun Poly Stretch Jersey':           { tab: 'poly',  sample: false, minYd: 1,  weightGPerYd: 370, gsm: 160 },
    'Spun Poly Jersey':                   { tab: 'poly',  sample: false, minYd: 1,  weightGPerYd: 320, gsm: 140 },
    'Knit Lining':                        { tab: 'poly',  sample: false, minYd: 1,  weightGPerYd: 280, gsm: 120 },
    'Scuba 220 gsm':                      { tab: 'poly',  sample: false, minYd: 1,  weightGPerYd: 510, gsm: 220 },
    'Heavy Scuba 280 gsm':                { tab: 'poly',  sample: false, minYd: 1,  weightGPerYd: 640, gsm: 280 },
    'Polyester Knit':                     { tab: 'poly',  sample: false, minYd: 1,  weightGPerYd: 510, gsm: 220 },
    'Poly French Terry (Stretch)':        { tab: 'lycra', sample: false, minYd: 1,  weightGPerYd: 530, gsm: 230 },
    'Sweatshirt Fleece (Unbrushed)':      { tab: 'lycra', sample: false, minYd: 1,  weightGPerYd: 690, gsm: 300 },
    'Brushed Sweatshirt Fleece':          { tab: 'lycra', sample: false, minYd: 1,  weightGPerYd: 690, gsm: 300 },
    'Poly Stretch Jersey':                { tab: 'poly',  sample: false, minYd: 1,  weightGPerYd: 390, gsm: 170 },
    'Brushed Poly Stretch Jersey':        { tab: 'poly',  sample: false, minYd: 1,  weightGPerYd: 410, gsm: 180 },
    'Textured Poly Jersey':               { tab: 'poly',  sample: false, minYd: 1,  weightGPerYd: 320, gsm: 140 },
    'Stretch Piqué':                      { tab: 'poly',  sample: false, minYd: 1,  weightGPerYd: 390, gsm: 170 },
  };

  // Sekme sirasi ve "All" gorunumundeki grup basliklari.
  const TAB_ORDER = ['knit', 'woven', 'poly', 'lycra', 'silk'];
  const TAB_LABELS = {
    knit: 'Cotton & Viscose Knit', woven: 'Woven', poly: 'Polyester',
    lycra: 'Sports & Technical', silk: 'Silk',
  };
  // PYO ana urunundeki custom.fabric_category → sekme.
  const CATEGORY_TAB = {
    'cotton knits': 'knit', 'cotton wovens': 'woven', 'twill & canvas': 'woven',
    'polyester': 'poly', 'sports & technical': 'lycra', 'silk': 'silk',
  };
  // Ortak "Designer Fabric Print" urununden gelen kumaslarin verisi; sayfa
  // yuklenirken <option data-shared> ozniteliklerinden doldurulur.
  const SHARED_META = {};
  const SHARED_USES = {};
  function usesFor(name) { return FABRIC_USE_CASES[name] || SHARED_USES[name] || []; }

  // Tabloda olmayan (ileride eklenecek) bir kumas kategorisiz ve "min 1" ile
  // gorunmesin: addan tahmin et. Tablodaki kayit her zaman onceliklidir.
  function metaFor(name) {
    if (FABRIC_META[name]) return FABRIC_META[name];
    if (SHARED_META[name]) return SHARED_META[name];
    const n = String(name || '').toLowerCase();
    let tab;
    if (/silk/.test(n)) tab = 'silk';
    else if (/lycra|softshell|rainwear|board short|mesh/.test(n)) tab = 'lycra';
    else if (/poly|scuba|piqu|spun/.test(n)) tab = /crepe|satin/.test(n) ? 'woven' : 'poly';
    else if (/poplin|lawn|voile|sateen|satin|linen|twill|canvas|muslin|crepe|quilting|woven/.test(n)) tab = 'woven';
    else tab = 'knit';
    const sublimation = tab === 'poly' || tab === 'lycra' || tab === 'silk' || /poly/.test(n);
    return { tab: tab, sample: false, minYd: sublimation ? 1 : 5 };
  }

  // === ECO PRINT (woven fabrics, 5–20 m → eco pigment, 20 m+ → reactive) ===
  const ECO_TAB = 'woven';
  const ECO_MAX_M = 20;
  const ECO_MAX_YD = 22; // ~20 m in yards

  function injectEcoStyles() {
    if (document.getElementById('jpf-eco-style')) return;
    const st = document.createElement('style');
    st.id = 'jpf-eco-style';
    st.textContent = [
      '.mp-fabric-option__eco{display:inline-flex;align-items:center;gap:4px;margin-top:6px;padding:3px 9px;background:rgba(0,166,81,.08);border:1px solid rgba(0,166,81,.22);border-radius:100px;font-size:10.5px;font-weight:600;color:#1f7a45;line-height:1.2;}',
      '.mp-eco-qty-note{display:flex;gap:7px;align-items:flex-start;margin:8px 0 0;padding:8px 12px;background:rgba(0,166,81,.07);border:1px solid rgba(0,166,81,.18);border-radius:8px;font-size:12px;line-height:1.45;color:#2e5c40;}',
      '.mp-eco-qty-note strong{color:#1f4630;}',
      '.mp-eco-qty-note[hidden]{display:none;}',
    ].join('\n');
    document.head.appendChild(st);
  }

  const VOLUME_TIERS = [
    { min: 500, discount: 0.30 },
    { min: 250, discount: 0.25 },
    { min: 50,  discount: 0.20 },
    { min: 0,   discount: 0.00 },
  ];

  const FABRIC_USE_CASES = {
    'Stretch Cotton Jersey — 210 gsm':    ['apparel', 'baby'],
    'Organic Cotton Jersey — 210 gsm':    ['apparel', 'baby'],
    'French Terry — 250 gsm':             ['hoodies', 'lounge', 'apparel'],
    'Brushed French Terry — 250 gsm':     ['hoodies', 'lounge'],
    'French Terry — 300 gsm':             ['hoodies', 'outerwear'],
    'Brushed French Terry — 300 gsm':     ['hoodies', 'outerwear'],
    'Rib Knit — 230 gsm':                 ['apparel', 'accessories'],
    'Viscose Jersey — 200 gsm':           ['apparel', 'dresses'],
    'Modal/Cotton Jersey — 200 gsm':      ['apparel', 'baby'],
    'Quilting Cotton — 120 gsm':          ['home decor', 'crafts'],
    'Cotton Voile — 80 gsm':              ['apparel', 'home decor', 'dresses'],
    '2 Layers Muslin (Gauze) — 120 gsm':  ['baby', 'apparel'],
    '4 Layers Muslin (Gauze) — 200 gsm':  ['baby', 'home decor'],
    'Woven Viscose — 120 gsm':            ['apparel', 'dresses'],
    'Cotton Canvas — 210 gsm':            ['bags', 'home decor'],
    'Cotton Canvas — 300 gsm':            ['bags', 'outerwear', 'upholstery'],
    'Swimsuit Lycra — 180 gsm':           ['swimwear', 'activewear'],
    'Sport Lycra — 230 gsm':              ['activewear'],
    'Softshell with Fleece — 300 gsm':    ['outerwear', 'activewear'],
    'Rainwear — 120 gsm':                 ['outerwear', 'bags'],
    'Board Short — 90 gsm':               ['swimwear', 'activewear'],
    'Fleece — 280 gsm':                   ['lounge', 'home decor', 'outerwear'],
    'Mesh (tulle-net)':                   ['accessories', 'costumes'],
    'Heavy Sport Lycra — 300 gsm':        ['activewear'],
    '100% Real Silk Satin — 90 gsm':      ['accessories', 'apparel', 'dresses'],
    'Cotton Lawn':                        ['dresses', 'blouses', 'scarves'],
    'Cotton Poplin 115 gsm':              ['shirting', 'quilting', 'dresses'],
    'Stretch Cotton Sateen':              ['dresses', 'bedding', 'apparel'],
    'Linen':                              ['apparel', 'home textiles', 'dresses'],
    'Cotton Twill 280 gsm':               ['trousers', 'jackets', 'upholstery'],
    'Cotton Canvas':                      ['bags', 'upholstery', 'home decor'],
    'Spun Poly Stretch Jersey':           ['t-shirts', 'activewear', 'dresses'],
    'Spun Poly Jersey':                   ['t-shirts', 'tops', 'dresses'],
    'Knit Lining':                        ['linings', 'underlayers'],
    'Scuba 220 gsm':                      ['dresses', 'skirts', 'activewear'],
    'Heavy Scuba 280 gsm':                ['jackets', 'skirts'],
    'Polyester Knit':                     ['t-shirts', 'dresses', 'kidswear'],
    'Poly French Terry (Stretch)':        ['sweatshirts', 'joggers', 'lounge'],
    'Sweatshirt Fleece (Unbrushed)':      ['hoodies', 'sweatshirts', 'joggers'],
    'Brushed Sweatshirt Fleece':          ['hoodies', 'sweatshirts', 'lounge'],
    'Poly Stretch Jersey':                ['t-shirts', 'activewear', 'dresses'],
    'Brushed Poly Stretch Jersey':        ['leggings', 'activewear', 'lounge'],
    'Textured Poly Jersey':               ['tops', 'dresses', 'blouses'],
    'Stretch Piqué':                      ['polo shirts', 'activewear', 'dresses'],
  };

  function discountFor(yards) {
    for (const t of VOLUME_TIERS) {
      if (yards >= t.min) return t.discount;
    }
    return 0;
  }

  // 12 Eki 2026: varyant fiyati YARD fiyati sayilip metre gorunumunde 1/0,9144
  // ile carpiliyordu → sayfa metre fiyatini ~%9 fazla gosteriyor, sepet ise
  // varyant fiyatindan kesiyordu (€25,08'lik Linen sayfada €27,43/m). Varyantin
  // birimi sepetteki adettir; sepet (main-cart-pyo) ayni adedi ve ayni fiyati
  // metre modunda "m", ABD modunda "yd" diye etiketler. Burada da donusum yok:
  // sayfada gorunen birim fiyat = sepetteki birim fiyat.
  function priceInUnit(eurPerUnit, unit) {
    return eurPerUnit;
  }
  function unitShort(unit) { return unit === 'meter' ? 'm' : 'yd'; }
  function unitLong(unit) { return unit === 'meter' ? 'meter' : 'yard'; }
  function unitLongPlural(unit) { return unit === 'meter' ? 'meters' : 'yards'; }

  const FX_CACHE_KEY = 'jpf_mp_fx_v1';
  const FX_CACHE_TTL = 6 * 60 * 60 * 1000;
  const CURRENCIES = ['USD', 'GBP', 'CHF', 'JPY', 'AUD', 'CAD'];
  const CURR_SYMBOL = { USD: '$', GBP: '£', CHF: 'CHF ', JPY: '¥', AUD: 'A$', CAD: 'C$', EUR: '€' };
  let fxRates = { USD: 1.16, GBP: 0.84, CHF: 0.96, JPY: 165, AUD: 1.65, CAD: 1.55 };

  async function loadFxRates() {
    try {
      const cached = localStorage.getItem(FX_CACHE_KEY);
      if (cached) {
        const data = JSON.parse(cached);
        if (Date.now() - data.ts < FX_CACHE_TTL) { fxRates = data.rates; return; }
      }
    } catch (e) {}
    try {
      const r = await fetch('https://api.frankfurter.app/latest?from=EUR&to=' + CURRENCIES.join(','));
      if (r.ok) {
        const data = await r.json();
        if (data && data.rates) {
          fxRates = data.rates;
          try { localStorage.setItem(FX_CACHE_KEY, JSON.stringify({ rates: fxRates, ts: Date.now() })); } catch (e) {}
        }
      }
    } catch (e) {}
  }

  function formatMoney(eurAmount, currency) {
    if (!currency || currency === 'EUR') return '€' + Number(eurAmount).toFixed(2);
    const rate = fxRates[currency];
    if (!rate) return '€' + Number(eurAmount).toFixed(2);
    const local = eurAmount * rate;
    if (currency === 'JPY') return CURR_SYMBOL[currency] + Math.round(local).toLocaleString();
    return CURR_SYMBOL[currency] + local.toFixed(2);
  }

  const DHL_EXP_BRACKETS = {
    0.5:[8.99,9.07,11.72,15.04,14.06,15.85,16.20,16.43,17.67],
    1:[8.99,9.07,12.70,15.04,19.02,21.75,22.10,22.84,25.78],
    2:[12.49,12.67,16.92,16.92,28.91,32.78,33.13,34.00,41.24],
    3:[17.33,17.60,22.42,22.42,37.57,43.03,43.37,44.32,54.19],
    5:[27.49,27.92,34.02,34.02,55.93,64.75,65.09,66.20,78.79],
    7:[33.25,33.68,43.18,43.18,70.41,81.55,81.89,83.24,103.39],
    10:[41.89,42.32,56.92,56.92,92.13,106.75,107.09,108.80,140.29],
    15:[52.09,52.42,69.42,69.42,115.83,135.65,135.99,137.90,169.19],
    20:[63.60,63.86,81.86,81.79,139.46,164.61,164.95,167.04,198.11],
    25:[79.41,79.67,102.19,102.19,163.15,190.62,190.95,193.35,224.11],
    30:[95.21,95.47,122.59,122.59,186.85,216.62,216.95,219.65,250.11],
  };
  const DHL_PERKG = {
    upto70:  [3.28,3.28,4.09,4.30,4.75,6.10,7.35,7.60,8.76],
    upto300: [3.29,3.29,4.10,4.31,4.76,6.11,7.36,7.61,8.77],
    above:   [3.30,3.30,4.11,4.32,4.78,6.14,7.37,7.64,8.80],
  };
  const FUEL = 0.45, MARGIN = 0.10, MULT = (1 + FUEL) * (1 + MARGIN);

  function dhlExpressEUR(zone, kg) {
    const zi = parseInt(zone) - 1;
    if (zi < 0 || zi > 8) return null;
    if (kg <= 0) kg = 0.5;
    let base;
    if (kg <= 30) {
      const keys = Object.keys(DHL_EXP_BRACKETS).map(Number).sort((a, b) => a - b);
      const bracket = keys.find(k => kg <= k) || 30;
      base = DHL_EXP_BRACKETS[bracket][zi];
    } else if (kg <= 70) base = kg * DHL_PERKG.upto70[zi];
    else if (kg <= 300) base = kg * DHL_PERKG.upto300[zi];
    else base = kg * DHL_PERKG.above[zi];
    return Math.round(base * MULT);
  }

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  function init(section) {
    if (section.dataset.mpInitialized === '1') return;
    section.dataset.mpInitialized = '1';

    const form = $('[data-marketplace-form]', section);
    const originalSelector = $('select.original-selector', form);
    if (!originalSelector) return;

    const userCountry = section.dataset.userCountry || 'US';
    const defaultMeasureUnit = (userCountry === 'US' || userCountry === 'CA' || userCountry === 'GB') ? 'inch' : 'cm';
    // Step 4.6 #2: locale-aware default size unit (yard for US/CA, meter elsewhere)
    const defaultSizeUnit = section.dataset.defaultSizeUnit || 'yard';

    const state = {
      currency: section.dataset.defaultCurrency || 'USD',
      unit: defaultSizeUnit,
      measureUnit: defaultMeasureUnit, // cm or inch — independent toggle
      qty: 1,
      currentFabric: null,
      currentVariantId: null,
      currentPriceEUR: 0,
      ddpZone: null,
      ddpCountry: null,
    };

    // Read repeat dims from data attrs
    const repeatHost = $('[data-pattern-repeat]', section);
    const cmW = repeatHost ? parseFloat(repeatHost.dataset.repeatW) || 0 : 0;
    const cmH = repeatHost ? parseFloat(repeatHost.dataset.repeatH) || 0 : 0;

    // Build fabric catalog
    const allFabrics = {};
    Array.from(originalSelector.options).forEach(opt => {
      const title = opt.dataset.fabricName || opt.text;
      const isSample = opt.dataset.isSample === '1';
      const priceCents = parseFloat(opt.dataset.priceCents || '0');
      const priceEUR = priceCents / 100;
      let fabricBase = isSample ? title.split(' / Sample')[0] : title;
      if (opt.dataset.shared === '1') {
        const d = opt.dataset;
        const inferred = metaFor(title); // SHARED_META henuz bos → addan tahmin
        const tab = CATEGORY_TAB[String(d.category || '').toLowerCase()] || inferred.tab;
        const grams = parseFloat(d.grams || '0'); // varyant agirligi: gram / metre
        SHARED_META[title] = {
          tab: tab, sample: false, shared: true,
          minYd: parseInt(d.min, 10) || (d.fabricType === 'polyester' ? 1 : inferred.minYd),
          gsm: parseInt(d.gsm, 10) || null,
          weightGPerYd: grams > 0 ? Math.round(grams * 0.9144) : undefined,
        };
        SHARED_USES[title] = String(d.usage || '').split('|')
          .map(u => u.trim().toLowerCase()).filter(Boolean).slice(0, 3);
      }
      if (!allFabrics[fabricBase]) {
        allFabrics[fabricBase] = { name: fabricBase, yardVariantId: null, yardPriceEUR: 0, sampleVariantId: null, samplePriceEUR: 0 };
      }
      if (isSample) {
        allFabrics[fabricBase].sampleVariantId = opt.value;
        allFabrics[fabricBase].samplePriceEUR = priceEUR;
      } else {
        allFabrics[fabricBase].yardVariantId = opt.value;
        allFabrics[fabricBase].yardPriceEUR = priceEUR;
      }
    });

    const selectedOpt = originalSelector.options[originalSelector.selectedIndex];
    if (selectedOpt) {
      const t = selectedOpt.dataset.fabricName || selectedOpt.text;
      const isSample = selectedOpt.dataset.isSample === '1';
      state.currentFabric = isSample ? t.split(' / Sample')[0] : t;
      // 29 Eyl 2026: numune secenegi kaldirildi. Varsayilan varyant bir numune
      // varyantiysa ayni kumasin metre/yard varyantina geciyoruz — aksi halde
      // arayuz, artik butonu olmayan bir modda kilitli kalirdi.
      state.unit = defaultSizeUnit;
      if (isSample) {
        const base = allFabrics[state.currentFabric];
        state.currentVariantId = (base && base.yardVariantId) || selectedOpt.value;
        state.currentPriceEUR = (base && base.yardPriceEUR) || 0;
      } else {
        state.currentVariantId = selectedOpt.value;
        state.currentPriceEUR = parseFloat(selectedOpt.dataset.priceCents || '0') / 100;
      }
    } else {
      state.currentFabric = Object.keys(allFabrics)[0];
      const f = allFabrics[state.currentFabric];
      state.currentVariantId = f.yardVariantId;
      state.currentPriceEUR = f.yardPriceEUR;
    }

    // === IMAGE PROTECTION ===
    const mainImg = $('.marketplace-product__main-image', section);
    if (mainImg) {
      mainImg.addEventListener('contextmenu', (e) => e.preventDefault());
      mainImg.addEventListener('dragstart', (e) => e.preventDefault());
      $$('.marketplace-product__main-image img', section).forEach(img => {
        img.addEventListener('contextmenu', (e) => e.preventDefault());
        img.addEventListener('dragstart', (e) => e.preventDefault());
        img.setAttribute('draggable', 'false');
      });

      // Watermark overlay — designer name + JPF Marketplace, scattered
      const designerName = (section.dataset.designerName || 'JPF MARKETPLACE').toUpperCase();
      const watermarkOverlay = document.createElement('div');
      watermarkOverlay.className = 'mp-watermark-overlay';
      const positions = [
        { top: '12%', left: '8%' },
        { top: '38%', left: '55%' },
        { top: '68%', left: '15%' },
        { top: '84%', left: '60%' },
        { top: '24%', left: '70%' },
      ];
      const wmText = `© ${designerName} · JPF MARKETPLACE`;
      positions.forEach(pos => {
        const t = document.createElement('div');
        t.className = 'mp-watermark-text';
        t.style.top = pos.top;
        t.style.left = pos.left;
        t.style.transform = 'rotate(-30deg)';
        t.textContent = wmText;
        watermarkOverlay.appendChild(t);
      });
      mainImg.appendChild(watermarkOverlay);
    }

    // === PATTERN REPEAT BADGE + UNIT TOGGLE ===
    const repeatBadgeValue = $('[data-repeat-value]', section);
    const repeatBadgeAlt = $('[data-repeat-alt]', section);
    const measureToggleBtns = $$('[data-measure-unit]', section);

    function updateRepeatBadge() {
      if (!repeatBadgeValue || !cmW || !cmH) return;
      const inchW = (cmW / 2.54).toFixed(1);
      const inchH = (cmH / 2.54).toFixed(1);
      if (state.measureUnit === 'inch') {
        repeatBadgeValue.textContent = `${inchW} × ${inchH} in`;
        if (repeatBadgeAlt) repeatBadgeAlt.textContent = `(${cmW} × ${cmH} cm)`;
      } else {
        repeatBadgeValue.textContent = `${cmW} × ${cmH} cm`;
        if (repeatBadgeAlt) repeatBadgeAlt.textContent = `(${inchW} × ${inchH} in)`;
      }
      measureToggleBtns.forEach(b => {
        b.classList.toggle('is-active', b.dataset.measureUnit === state.measureUnit);
      });
      renderInlineRuler();
    }

    measureToggleBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        state.measureUnit = btn.dataset.measureUnit;
        measureToggleBtns.forEach(b => {
          b.classList.toggle('is-active', b.dataset.measureUnit === state.measureUnit);
        });
        renderInlineRuler();
        if (repeatBadgeValue && cmW && cmH) {
          const inchW = (cmW / 2.54).toFixed(1);
          const inchH = (cmH / 2.54).toFixed(1);
          if (state.measureUnit === 'inch') {
            repeatBadgeValue.textContent = inchW + ' × ' + inchH + ' in';
            if (repeatBadgeAlt) repeatBadgeAlt.textContent = '(' + cmW + ' × ' + cmH + ' cm)';
          } else {
            repeatBadgeValue.textContent = cmW + ' × ' + cmH + ' cm';
            if (repeatBadgeAlt) repeatBadgeAlt.textContent = '(' + inchW + ' × ' + inchH + ' in)';
          }
        }
      });
    });

    // === INLINE RULER (locale + toggle aware) ===
    function renderInlineRuler() {
      const overlay = $('[data-inline-ruler]', section);
      if (!overlay) return;
      if (!cmW || !cmH) { overlay.style.display = 'none'; return; }
      const xRuler = $('[data-ruler-x]', overlay);
      const yRuler = $('[data-ruler-y]', overlay);
      if (!xRuler || !yRuler) return;

      const useInches = state.measureUnit === 'inch';
      const unitLabel = useInches ? 'in' : 'cm';
      const valueW = useInches ? (cmW / 2.54) : cmW;
      const valueH = useInches ? (cmH / 2.54) : cmH;
      const stepX = useInches ? 1 : (cmW <= 30 ? 5 : 10);
      const stepY = useInches ? 1 : (cmH <= 30 ? 5 : 10);
      const maxX = Math.ceil(valueW);
      const maxY = Math.ceil(valueH);

      let xHtml = '';
      for (let v = 0; v <= maxX; v += stepX) {
        const pct = (v / valueW) * 100;
        if (pct > 100) continue;
        xHtml += `<div class="mp-ruler-tick mp-ruler-tick--x" style="left:${pct}%"><span>${v}</span></div>`;
      }
      xRuler.innerHTML = xHtml + `<div class="mp-ruler-unit-label">${unitLabel}</div>`;

      let yHtml = '';
      for (let v = 0; v <= maxY; v += stepY) {
        const pct = (v / valueH) * 100;
        if (pct > 100) continue;
        yHtml += `<div class="mp-ruler-tick mp-ruler-tick--y" style="top:${pct}%"><span>${v}</span></div>`;
      }
      yRuler.innerHTML = yHtml;

      overlay.style.display = '';
    }

    // === CUSTOM SIZE NOTE → CART PROPERTY ===
    const customNoteTextarea = $('[data-custom-note-input]', section);
    const customNoteHidden = $('[data-custom-note-hidden]', section);
    if (customNoteTextarea && customNoteHidden) {
      customNoteTextarea.addEventListener('input', () => {
        customNoteHidden.value = customNoteTextarea.value;
      });
    }

    // === ECO PRINT QUANTITY NOTE (woven fabrics under 20 m) ===
    const qtyRowEl = $('[data-marketplace-qty]', section);
    let ecoQtyNote = null;
    if (qtyRowEl) {
      ecoQtyNote = document.createElement('div');
      ecoQtyNote.className = 'mp-eco-qty-note';
      ecoQtyNote.hidden = true;
      qtyRowEl.insertAdjacentElement('afterend', ecoQtyNote);
    }

    // === FABRIC MODAL ===
    const modal = $('[data-fabric-modal]', section);
    const grid = $('[data-fabric-grid]', modal);
    const tabs = $$('[data-fabric-tab]', modal);
    const searchInput = $('[data-fabric-search]', modal);
    let currentTab = 'all';
    let searchTerm = '';

    // Numune varyanti (29 Eyl 2026'da secenek kaldirildi) kumas degildir;
    // metre/yard varyanti olmayan kayit listede gosterilmez.
    const pickable = Object.values(allFabrics).filter(f => f.yardVariantId);
    tabs.forEach(t => {
      const key = t.dataset.fabricTab;
      if (key !== 'all') t.hidden = !pickable.some(f => metaFor(f.name).tab === key);
    });

    function renderModalGrid() {
      let items;
      if (searchTerm) {
        items = pickable.filter(f => {
          const meta = metaFor(f.name);
          const tags = usesFor(f.name);
          const haystack = (f.name + ' ' + tags.join(' ') + ' ' + (meta.tab || '')).toLowerCase();
          return haystack.includes(searchTerm);
        });
      } else if (currentTab === 'all') {
        items = pickable.slice().sort((a, b) =>
          TAB_ORDER.indexOf(metaFor(a.name).tab) - TAB_ORDER.indexOf(metaFor(b.name).tab));
      } else {
        items = pickable.filter(f => metaFor(f.name).tab === currentTab);
      }
      const grouped = !searchTerm && currentTab === 'all';
      let lastGroup = null;

      const isMeter = state.unit === 'meter';
      const uShort = unitShort(state.unit === 'sample' ? 'yard' : state.unit);

      if (items.length === 0) {
        grid.innerHTML = `<div class="mp-modal__no-results">No fabrics match "<strong>${escapeHtml(searchTerm)}</strong>". Try a different keyword like apparel, swimwear, hoodies, or bags.</div>`;
        return;
      }

      grid.innerHTML = items.map(f => {
        const meta = metaFor(f.name);
        const isCurrent = f.name === state.currentFabric;
        const baseDisplay = priceInUnit(f.yardPriceEUR, isMeter ? 'meter' : 'yard');
        const minDisplay = meta.minYd || 1;
        const parts = splitFabricName(f.name);
        const subParts = [];
        if (parts.weight) subParts.push(parts.weight);
        else if (meta.gsm && !/gsm/i.test(parts.display)) subParts.push(meta.gsm + ' gsm');
        subParts.push(`min ${minDisplay} ${uShort}`);
        const subtitle = subParts.join(' · ');
        const selectedLabel = isCurrent ? '<span class="mp-fabric-option__selected">Selected</span>' : '';
        const tags = usesFor(f.name);
        const tagsHtml = tags.length
          ? `<div class="mp-fabric-option__tags">${tags.map(t => `<span class="mp-fabric-option__tag">${escapeHtml(t)}</span>`).join('')}</div>`
          : '';
        const ecoHtml = (meta.tab === ECO_TAB)
          ? `<span class="mp-fabric-option__eco">🌿 Eco Print ${isMeter ? '5–' + ECO_MAX_M + ' m' : '5–' + ECO_MAX_YD + ' yd'}</span>`
          : '';
        let groupHtml = '';
        if (grouped && meta.tab !== lastGroup) {
          lastGroup = meta.tab;
          groupHtml = `<div class="mp-modal__group">${escapeHtml(TAB_LABELS[meta.tab] || '')}</div>`;
        }
        return `${groupHtml}
          <button type="button" class="mp-fabric-option${isCurrent ? ' is-current' : ''}" data-fabric-pick="${escapeAttr(f.name)}">
            ${selectedLabel}
            <div class="mp-fabric-option__name">${escapeHtml(parts.display)}</div>
            <div class="mp-fabric-option__sub">${escapeHtml(subtitle)}</div>
            <div class="mp-fabric-option__price">${formatMoney(baseDisplay, state.currency)}</div>
            ${ecoHtml}
            ${tagsHtml}
          </button>
        `;
      }).join('');
    }

    if (searchInput) {
      searchInput.addEventListener('input', () => {
        searchTerm = searchInput.value.trim().toLowerCase();
        // When search is active, deemphasize tabs visually
        tabs.forEach(t => t.classList.toggle('is-dimmed', !!searchTerm));
        renderModalGrid();
      });
    }

    function setTab(tab) {
      currentTab = tab;
      tabs.forEach(t => {
        const active = t.dataset.fabricTab === tab;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      renderModalGrid();
    }

    tabs.forEach(t => t.addEventListener('click', () => {
      if (searchInput && searchInput.value) {
        searchInput.value = '';
        searchTerm = '';
        tabs.forEach(tt => tt.classList.remove('is-dimmed'));
      }
      setTab(t.dataset.fabricTab);
    }));

    $$('[data-open-fabric-modal]', section).forEach(btn => {
      btn.addEventListener('click', () => {
        currentTab = 'all';
        if (searchInput) {
          searchInput.value = '';
          searchTerm = '';
          tabs.forEach(tt => tt.classList.remove('is-dimmed'));
        }
        setTab('all');
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
      });
    });

    $$('[data-close-fabric-modal]', modal).forEach(el => {
      el.addEventListener('click', () => { modal.hidden = true; document.body.style.overflow = ''; });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !modal.hidden) { modal.hidden = true; document.body.style.overflow = ''; }
    });

    grid.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-fabric-pick]');
      if (!btn) return;
      pickFabric(btn.dataset.fabricPick);
      modal.hidden = true;
      document.body.style.overflow = '';
    });

    function pickFabric(fabricName) {
      state.currentFabric = fabricName;
      const meta = metaFor(fabricName);
      if (state.unit === 'sample' && !meta.sample) state.unit = defaultSizeUnit;
      applyVariantForState();
    }

    function applyVariantForState() {
      const f = allFabrics[state.currentFabric];
      if (!f) return;
      let variantId, priceEUR;
      if (state.unit === 'sample' && f.sampleVariantId) {
        variantId = f.sampleVariantId;
        priceEUR = f.samplePriceEUR;
      } else {
        variantId = f.yardVariantId;
        priceEUR = f.yardPriceEUR;
      }
      state.currentVariantId = variantId;
      state.currentPriceEUR = priceEUR;
      originalSelector.value = variantId;
      originalSelector.dispatchEvent(new Event('change', { bubbles: true }));
      refreshUI();
    }

    // === SIZE BUTTONS ===
    const sizeButtons = $$('[data-size]', section);
    const sizeNote = $('[data-size-note]', section);

    sizeButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        const newSize = btn.dataset.size;
        const meta = metaFor(state.currentFabric);
        if (newSize === 'sample' && !meta.sample) {
          if (sizeNote) sizeNote.hidden = false;
          return;
        }
        if (sizeNote) sizeNote.hidden = true;
        const wasUnit = state.unit;
        state.unit = newSize;
        if (newSize === 'sample') {
          state.qty = 1;
        } else if (wasUnit === 'sample') {
          state.qty = meta.minYd || 1;
        }
        applyVariantForState();
      });
    });

    // === QUANTITY ===
    const qtyInput = $('[data-qty-input]', section);
    const qtyDownBtns = $$('[data-quantity="down"]', section);
    const qtyUpBtns = $$('[data-quantity="up"]', section);

    qtyDownBtns.forEach(btn => btn.addEventListener('click', (e) => {
      e.preventDefault();
      const meta = metaFor(state.currentFabric);
      const min = (state.unit === 'sample') ? 1 : (meta.minYd || 1);
      state.qty = Math.max(min, state.qty - 1);
      qtyInput.value = state.qty;
      refreshUI();
    }));
    qtyUpBtns.forEach(btn => btn.addEventListener('click', (e) => {
      e.preventDefault();
      const max = (state.unit === 'sample') ? 1 : 9999;
      state.qty = Math.min(max, state.qty + 1);
      qtyInput.value = state.qty;
      refreshUI();
    }));
    qtyInput.addEventListener('change', () => {
      const meta = metaFor(state.currentFabric);
      const min = (state.unit === 'sample') ? 1 : (meta.minYd || 1);
      let v = parseInt(qtyInput.value, 10);
      if (isNaN(v) || v < min) v = min;
      if (state.unit === 'sample') v = 1;
      state.qty = v;
      qtyInput.value = v;
      refreshUI();
    });

    // === CURRENCY ===
    const currencyBtns = $$('[data-currency]', section);
    currencyBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        state.currency = btn.dataset.currency;
        currencyBtns.forEach(b => b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'));
        refreshUI();
        renderModalGrid();
      });
    });

    // === DDP ===
    const ddpCountrySel = $('[data-ddp-country]', section);
    const ddpResult = $('[data-ddp-result]', section);
    const ddpShipping = $('[data-ddp-shipping]', section);
    const ddpAllin = $('[data-ddp-allin]', section);
    const ddpQtyLabel = $('[data-ddp-qty-label]', section);
    const ddpDays = $('[data-ddp-days]', section);
    const ddpHint = $('[data-ddp-hint]', section);

// === DDP listener ===
    // Snippet value format: "zone|currency|countryName"
    // Examples: "1|USD|United States", "4|EUR|Germany", "tr|EUR|Turkey"
    ddpCountrySel.addEventListener('change', () => {
      const val = ddpCountrySel.value;
      if (!val) { state.ddpZone = null; state.ddpCountry = null; ddpResult.hidden = true; return; }
      const parts = val.split('|');
      state.ddpZone = parts[0];
      state.ddpCountry = parts[2] || '';

// Find currency anywhere in parts (resilient to format order changes)
      const ddpCurrency = parts
        .map(p => String(p || '').toUpperCase().trim())
        .find(p => p === 'USD' || p === 'EUR');
if (ddpCurrency) {
        state.currency = ddpCurrency;
        currencyBtns.forEach(b => {
          b.setAttribute('aria-pressed', b.dataset.currency === state.currency ? 'true' : 'false');
        });
      }

      // Sync size unit from country name (US/Canada → yard, rest → meter)
      if (state.unit !== 'sample') {
        const c = String(state.ddpCountry || '').toLowerCase().trim();
        const isYardCountry = (
          c === 'united states' || c === 'usa' || c === 'us' ||
          c === 'canada' || c === 'ca'
        );
        state.unit = isYardCountry ? 'yard' : 'meter';
      }


      refreshUI();
      renderModalGrid();
    });

    function refreshDDP() {
      if (!state.ddpZone) { ddpResult.hidden = true; return; }
      const meta = metaFor(state.currentFabric);
      const isSample = state.unit === 'sample';
      const isMeter = state.unit === 'meter';
      const previewQty = isSample ? 1 : Math.max(state.qty, meta.minYd || 5);
      const previewYards = isSample ? 0.05 : (isMeter ? previewQty * 1.0936 : previewQty);
      const kg = isSample ? 0.1 : (previewYards * (meta.weightGPerYd || 500)) / 1000;
      const uShort = unitShort(state.unit === 'sample' ? 'yard' : state.unit);

      if (state.ddpZone === 'tr') {
        ddpResult.hidden = false;
        ddpShipping.textContent = '~€10';
        ddpDays.textContent = '1-2';
        const perUnit = priceInUnit(state.currentPriceEUR, state.unit === 'meter' ? 'meter' : 'yard') + (10 / previewQty);
        ddpAllin.textContent = formatMoney(perUnit, state.currency) + ' / ' + uShort;
        ddpQtyLabel.textContent = `(at ${previewQty} ${unitLongPlural(state.unit === 'sample' ? 'yard' : state.unit)})`;
        ddpHint.hidden = true;
        return;
      }

      const shipEUR = dhlExpressEUR(state.ddpZone, kg);
      if (shipEUR == null) { ddpResult.hidden = true; return; }

      let days = '5';
      if (state.ddpZone === '1' || state.ddpZone === '2') days = '2-4';
      else if (state.ddpZone === '3') days = '3-5';
      else if (state.ddpZone === '4') days = '3-5';
      else days = '4-7';
      ddpDays.textContent = days;
      ddpShipping.textContent = formatMoney(shipEUR, state.currency);

      const pricePerDisplayUnitEUR = priceInUnit(state.currentPriceEUR, state.unit === 'meter' ? 'meter' : 'yard');
      const totalEUR = (pricePerDisplayUnitEUR * previewQty) + shipEUR;
      const allinPerUnit = totalEUR / previewQty;
      ddpAllin.textContent = formatMoney(allinPerUnit, state.currency) + ' / ' + uShort;
      ddpQtyLabel.textContent = isSample ? '(per sample)' : `(at ${previewQty} ${unitLongPlural(state.unit)})`;

      if (!isSample) {
        const currentInYards = previewQty; // kademe esigi sepetteki adede gore, donusum yok
        const nextTierYards = currentInYards < 50 ? 50 : (currentInYards < 250 ? 250 : (currentInYards < 500 ? 500 : null));
        if (nextTierYards && (nextTierYards - currentInYards) <= 100) {
          const nextDiscount = discountFor(nextTierYards);
          const projectedFabricEUR = state.currentPriceEUR * (1 - nextDiscount) * nextTierYards;
          const projKg = (nextTierYards * (meta.weightGPerYd || 500)) / 1000;
          const projShipEUR = dhlExpressEUR(state.ddpZone, projKg);
          if (projShipEUR != null) {
            const projAllinPerYd = (projectedFabricEUR + projShipEUR) / nextTierYards;
            const projAllinPerUnit = priceInUnit(projAllinPerYd, state.unit === 'meter' ? 'meter' : 'yard');
            const savingsPerUnit = allinPerUnit - projAllinPerUnit;
            const tierDisplayQty = nextTierYards;
            const addQty = tierDisplayQty - previewQty;
            if (savingsPerUnit > 0.5 && addQty > 0) {
              ddpHint.hidden = false;
              ddpHint.innerHTML = `💡 Add ${addQty} more ${uShort} (total ${tierDisplayQty}) → ${formatMoney(projAllinPerUnit, state.currency)}/${uShort} (save ${formatMoney(savingsPerUnit, state.currency)}/${uShort})`;
            } else { ddpHint.hidden = true; }
          }
        } else { ddpHint.hidden = true; }
      } else { ddpHint.hidden = true; }

      ddpResult.hidden = false;
    }

    // === TIER TABLE ===
    const tierTable = $('[data-marketplace-tier-pricing]', section);
    const tierFabricLabel = $('[data-tier-fabric-label]', section);
    const tierHeaderUnit = $('[data-tier-header-unit]', section);
    const tierQtyHeader = $('[data-tier-qty-header]', section);

    function refreshTierTable() {
      if (!tierTable) return;
      const f = allFabrics[state.currentFabric];
      if (!f) return;
      tierFabricLabel.textContent = state.currentFabric;
      const isMeter = state.unit === 'meter';
      const uShort = unitShort(state.unit === 'sample' ? 'yard' : state.unit);
      if (tierHeaderUnit) tierHeaderUnit.textContent = uShort;
      if (tierQtyHeader) tierQtyHeader.textContent = isMeter ? 'Quantity (meters)' : 'Quantity (yards)';

      const tiers = [0, 50, 250, 500];
      const tierLabels = [
        // Esikler sepetteki adede gore (cart-pyo: real_qty >= 50 / 250 / 500).
        '1–49 ' + uShort,
        '50+ ' + uShort,
        '250+ ' + uShort,
        '500+ ' + uShort,
      ];
      tiers.forEach((t, i) => {
        const row = $(`[data-tier="${t}"]`, tierTable);
        if (row) {
          const labelCell = row.querySelector('td:first-child');
          if (labelCell) labelCell.textContent = tierLabels[i];
        }
        const cell = $(`[data-tier-price="${t}"]`, tierTable);
        if (!cell) return;
        const disc = discountFor(t === 0 ? 1 : t);
        const priceEUR = f.yardPriceEUR * (1 - disc);
        const displayPrice = priceInUnit(priceEUR, isMeter ? 'meter' : 'yard');
        cell.textContent = formatMoney(displayPrice, state.currency) + ' / ' + uShort;
      });
    }

    function refreshUI() {
      const meta = metaFor(state.currentFabric);
      const isSample = state.unit === 'sample';
      const isMeter = state.unit === 'meter';
      const minDisplay = isSample ? 1 : (meta.minYd || 1);
      const uShort = unitShort(state.unit === 'sample' ? 'yard' : state.unit);

      sizeButtons.forEach(btn => {
        const sz = btn.dataset.size;
        btn.classList.toggle('is-active', sz === state.unit);
        if (sz === 'sample') {
          // Kumas tablosu "numune var" dese bile ortada fiyatli bir numune
          // varyanti yoksa buton acilmamali — yoksa musteriye €0,00 gosteriyor.
          const sf = allFabrics[state.currentFabric];
          const hasSampleVariant = !!(sf && sf.sampleVariantId && sf.samplePriceEUR > 0);
          if (!meta.sample || !hasSampleVariant) {
            btn.classList.add('is-disabled');
            btn.disabled = true;
            btn.setAttribute('title', 'Samples available only on polyester & silk fabrics. Cotton fabrics → try our Swatch Pack.');
          } else {
            btn.classList.remove('is-disabled');
            btn.disabled = false;
            btn.removeAttribute('title');
            const priceEl = $('[data-sample-price]', btn);
            if (priceEl) priceEl.textContent = formatMoney(sf.samplePriceEUR, state.currency);
          }
        }
      });
      if (sizeNote && meta.sample) sizeNote.hidden = true;

      qtyInput.min = minDisplay;
      if (isSample) {
        qtyInput.value = 1;
        state.qty = 1;
        qtyInput.disabled = true;
      } else {
        qtyInput.disabled = false;
        if (state.qty < minDisplay) {
          state.qty = minDisplay;
          qtyInput.value = minDisplay;
        }
      }
      const minInline = $('[data-min-inline]', section);
      const minVal = $('[data-min-value]', section);
      const minUnitInline = $('[data-min-unit-inline]', section);
      if (minInline) {
        if (isSample) minInline.hidden = true;
        else {
          minInline.hidden = false;
          minVal.textContent = minDisplay;
          minUnitInline.textContent = uShort;
        }
      }

      const qtyUnitLabel = $('[data-qty-unit-label]', section);
      if (qtyUnitLabel) {
        qtyUnitLabel.textContent = isSample ? '(sample)' : `(${unitLongPlural(state.unit)})`;
      }

      // Eco print note — woven fabrics under 20 m are produced with eco pigment inks
      if (ecoQtyNote) {
        const isWoven = (meta.tab === ECO_TAB);
        const qtyMeters = isSample ? 0 : (isMeter ? state.qty : state.qty * 0.9144);
        if (isWoven && !isSample && qtyMeters > 0 && qtyMeters < ECO_MAX_M) {
          ecoQtyNote.hidden = false;
          ecoQtyNote.innerHTML = '<span aria-hidden="true">🌿</span><span>This quantity is produced with <strong>Eco Print</strong> — same price, same quality. Increase to ' +
            (isMeter ? ECO_MAX_M + ' m' : ECO_MAX_YD + ' yd') +
            '+ and we switch to <strong>reactive printing</strong> automatically.</span>';
        } else {
          ecoQtyNote.hidden = true;
        }
      }

      const fabricNameEl = $('[data-fabric-name]', section);
      if (fabricNameEl) fabricNameEl.textContent = state.currentFabric;
      // Ortak urun satiri deseni kendi tasimaz: desen adi/gorseli yalniz o zaman gonderilir.
      $$('[data-shared-prop]', section).forEach(inp => { inp.disabled = !meta.shared; });
      const fabricSubEl = $('[data-fabric-sub]', section);
      if (fabricSubEl) {
        if (!fabricSubEl.dataset.defaultText) fabricSubEl.dataset.defaultText = fabricSubEl.textContent.trim();
        fabricSubEl.textContent = (meta.tab === 'poly' || meta.tab === 'lycra') ? 'Sublimation print'
          : meta.tab === 'silk' ? 'Digital print' : fabricSubEl.dataset.defaultText;
      }
      const fabricCard = $('[data-marketplace-fabric-card]', section);
      if (fabricCard) fabricCard.dataset.currentFabric = state.currentFabric;

      // Price display — hero = actual selected variant price + volume discount hint
      const heroEl = $('[data-price-hero]', section);
      const priceUnit = $('[data-unit-label]', section);
      const discountHint = $('[data-discount-hint]', section);

      if (isSample) {
        if (heroEl) heroEl.innerHTML = formatMoney(state.currentPriceEUR, state.currency) +
          (state.currency !== 'EUR' ? ` <span class="marketplace-product__price-eur-fallback">(${formatMoney(state.currentPriceEUR, 'EUR')})</span>` : '');
        if (priceUnit) priceUnit.textContent = '/ sample';
        if (discountHint) discountHint.style.display = 'none';
      } else {
        const displayPrice = priceInUnit(state.currentPriceEUR, isMeter ? 'meter' : 'yard');
        if (heroEl) heroEl.innerHTML = formatMoney(displayPrice, state.currency) +
          (state.currency !== 'EUR' ? ` <span class="marketplace-product__price-eur-fallback">(${formatMoney(displayPrice, 'EUR')})</span>` : '');
        if (priceUnit) priceUnit.textContent = '/ ' + unitLong(state.unit);
        if (discountHint) discountHint.style.display = '';
      }

      refreshTierTable();
      refreshDDP();
    }

// First render — call ruler/badge AFTER all functions are defined
    refreshUI();
    if (typeof updateRepeatBadge === 'function') updateRepeatBadge();
    if (typeof renderInlineRuler === 'function') renderInlineRuler();
    loadFxRates().then(refreshUI);

    // If DDP selector has a pre-selected value (e.g. Liquid pre-selected TR for Turkish users),
    // trigger change to compute shipping AND sync currency/unit
if (ddpCountrySel && ddpCountrySel.value) {
      ddpCountrySel.dispatchEvent(new Event('change'));
    }
  }

  function escapeHtml(s) { return String(s || '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); }
  function escapeAttr(s) { return escapeHtml(s); }

  function splitFabricName(fullName) {
    const m = String(fullName || '').match(/^(.+?)\s*—\s*(.+)$/);
    if (m) return { display: m[1].trim(), weight: m[2].trim() };
    // PYO adlarinin bir kismi gramaji " - 120 gsm" / " ~ 230 gsm" ile ayirir.
    const m2 = String(fullName || '').match(/^(.+?)\s+[-~–]\s+(\d+\s*gsm)$/i);
    if (m2) return { display: m2[1].trim(), weight: m2[2].trim() };
    return { display: fullName, weight: '' };
  }

  function boot() {
    injectEcoStyles();
    document.querySelectorAll('[data-section-type="main-marketplace-product"]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }

  document.addEventListener('shopify:section:load', (e) => {
    const target = e.target.querySelector('[data-section-type="main-marketplace-product"]');
    if (target) { target.dataset.mpInitialized = ''; init(target); }
  });

  // ============================================================
  // Zoom lightbox close UX — ESC + backdrop click + custom close button
  // ============================================================
  function attachZoomCloseHandlers() {
    let injected = false;
    const observer = new MutationObserver(() => {
      const lightbox = document.querySelector('.gallery-lightbox, .fancybox-container, .lightbox-content, [class*="lightbox"]:not([hidden])');
      const isOpen = lightbox && lightbox.offsetParent !== null;

      if (isOpen && !injected) {
        injected = true;
        document.body.style.cursor = 'zoom-out';

        if (!document.querySelector('.mp-zoom-close-btn')) {
          const btn = document.createElement('button');
          btn.className = 'mp-zoom-close-btn';
          btn.setAttribute('aria-label', 'Close zoom');
          btn.textContent = '×';
          btn.addEventListener('click', closeAnyLightbox);
          document.body.appendChild(btn);
        }

        lightbox.style.cursor = 'zoom-out';
        lightbox.addEventListener('click', (e) => {
          if (e.target === lightbox || e.target.classList.contains('lightbox-image-container')) {
            closeAnyLightbox();
          }
        }, { once: false });
      }

      if (!isOpen && injected) {
        injected = false;
        document.body.style.cursor = '';
        const btn = document.querySelector('.mp-zoom-close-btn');
        if (btn) btn.remove();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
  }

  function closeAnyLightbox() {
    const closeBtns = document.querySelectorAll('.lightbox-close, .fancybox-button--close, .gallery-lightbox-close, [data-close-lightbox], [class*="close"]');
    closeBtns.forEach(b => {
      if (b.offsetParent !== null) b.click();
    });
    document.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', keyCode: 27, which: 27, bubbles: true }));
    document.querySelectorAll('.gallery-lightbox, .fancybox-container, .lightbox-content').forEach(el => {
      el.style.display = 'none';
      el.setAttribute('hidden', '');
    });
    document.body.style.overflow = '';
    document.body.style.cursor = '';
    const ownBtn = document.querySelector('.mp-zoom-close-btn');
    if (ownBtn) ownBtn.remove();
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const visibleLightbox = document.querySelector('.gallery-lightbox:not([hidden]), .fancybox-container:not([hidden]), .lightbox-content:not([hidden])');
      if (visibleLightbox && visibleLightbox.offsetParent !== null) {
        closeAnyLightbox();
      }
    }
  });

  attachZoomCloseHandlers();
})();
